<!--
  创建时间：2023/7/27 16:19
  创建人：toyehuang
  文件描述：head 页面头部布局
-->
<template>
  <header class="layout-head">
    <div class="layout_header_top def-w f-b-c fc99">
      <div class="top-left f-b-c">
        <span>{{ site.name }}欢迎您！</span>
      </div>
      <div class="top-right">
        咨询电话：<span class="fc33">{{ site.consultHotline }}</span>
        （工作时间：{{ site.workTime }}）
      </div>
    </div>
    <div class="layout_head_container">
      <div class="def-w f-b-c">
        <a href="/" :title="site.name">
          <img :src="site.logo" :alt="site.name">
        </a>
        <head-search />
      </div>
    </div>
    <head-nav v-if="!$route.meta.hideNav" />
  </header>
</template>

<script>
import HeadSearch from "@/layout/components/LayoutHead/HeadSearch.vue";
import HeadNav from "@/layout/components/LayoutHead/HeadNav/index.vue";
import { mapGetters } from "vuex";

export default {
  name: "LayoutHead",
  components: { HeadNav, HeadSearch },
  props: {
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["site"]),
    registerUrl() {
      return process.env.VUE_APP_REGISTER_LINK
    }
  },
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style scoped lang="scss">
.layout-head{
  width: 100%;
  background-color: #f5f5f5;
  //border-bottom: 2px solid $--color-primary;
  //&.no-border{
  //  border-bottom: none;
  //}
  .layout_header_top{
    height: 40px;
    .top-left{
      .button-group{
        white-space: nowrap;
      }
    }
    .top-right{

    }
  }
  .layout_head_container{
    //background: url("@/assets/images/head_bg.png") no-repeat center / cover;
		background-color: #fff;
    .def-w{
      height: 100px;
    }
  }
}
</style>
